const cartElement = document.querySelector("#cart");

if (cartElement) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class" && mutation.target.id === "cart") {
        setTimeout(() => {
            BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
            BSS_B2B.observer.cartSubject.listenCartCheckout()
        },700)
      }
    }
  });

  observer.observe(cartElement, {
    attributes: true,
    attributeFilter: ["class"]
  });

}

const summaryLine = document.querySelector(".cart-summary-line");

if (summaryLine) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        setTimeout(() => {
            if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
                BSS_B2B.observer.cartSubject.listenCartCheckout()
            }
        },1500);
      } 
    }
  });

  observer.observe(summaryLine, {
    attributes: true,         
    childList: true,         
    characterData: true,    
    subtree: true       
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`#Search-In-Template`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 1200);
  });
});

